import React from "react";
import { Box, Typography } from "@mui/material";

const StatsCard = ({
  label,
  value,
  icon,
  color = "#1E40AF",
  bgColor,
  gradient,
  onClick,
  sx = {},
}) => {
  const hasGradient = !!gradient;

  return (
    <Box
      onClick={onClick}
      sx={{
        p: 2.5,
        borderRadius: "16px",
        background: hasGradient ? gradient : bgColor || "#fff",
        border: hasGradient ? "none" : "1px solid #eef0f6",
        display: "flex",
        alignItems: "center",
        gap: 2,
        cursor: onClick ? "pointer" : "default",
        transition: "all 0.3s ease",
        boxShadow: hasGradient
          ? "0 8px 25px rgba(0,0,0,0.12)"
          : "0 2px 12px rgba(0,0,0,0.04)",
        "&:hover": {
          transform: "translateY(-3px)",
          boxShadow: hasGradient
            ? "0 12px 35px rgba(0,0,0,0.18)"
            : "0 6px 20px rgba(0,0,0,0.08)",
        },
        ...sx,
      }}
    >
      {icon && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 50,
            height: 50,
            borderRadius: "14px",
            bgcolor: hasGradient ? "rgba(255,255,255,0.2)" : `${color}15`,
            color: hasGradient ? "#fff" : color,
            fontSize: 24,
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
      )}
      <Box>
        <Typography
          sx={{
            fontWeight: 800,
            color: hasGradient ? "#fff" : "#1a1a2e",
            fontSize: "1.75rem",
            lineHeight: 1.1,
          }}
        >
          {value}
        </Typography>
        <Typography
          sx={{
            color: hasGradient ? "rgba(255,255,255,0.85)" : "#8b8fa3",
            fontSize: "0.8rem",
            fontWeight: 600,
            mt: 0.5,
            textTransform: "uppercase",
            letterSpacing: "0.06em",
          }}
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default StatsCard;
